export default "__VITE_ASSET__w3xLzK6T__"